import { API_HEADER_AUTH_KEY } from './global_constants';
// import base64 	from 'base-64';
import Cookies from 'universal-cookie';
import axios from 'axios';

/* Creating axios instance */
var axiosInstance = axios.create({
    headers: { "authkey": API_HEADER_AUTH_KEY },
});

/* Request interceptor */
// axiosInstance.interceptors.request.use((request)=>{
// 	// const cookies 	=	new Cookies();
// 	// let userDetails =	cookies.get('user_details');
// 	// if(userDetails && userDetails._id) request.data['user_id'] = userDetails._id;
// 	// if(userDetails && userDetails.token) request.headers['authorization'] = userDetails.token;

// 	/* To identify request is sending from web */
// 	// if(!request.data.api_type) 		request.data.api_type 		= 	"web";
// 	// if(!request.data.guest_id) 		request.data.guest_id 	 	= 	cookies.get('guest_id') || "";
// 	// if(!request.data.language_id) 	request.data.language_id 	=	cookies.get('preferred_language') || DEFAULT_LANGUAGE_ID;
// 	// if(!request.data.lang_code) 	request.data.lang_code 	=	cookies.get('preferred_language') || "en";
// 	let encodedData	=	request.data;
// 	request.data 	=	{data: encodedData};
// 	return request;
// },(error)=>{
// 	/* Do something with request error */
// 	return Promise.reject(error);
// });

axiosInstance.interceptors.request.use((request) => {
    const token = localStorage.getItem('token');

    request.headers = request.headers || {};
 
    if (token) {
        // request.headers['Authorization'] = `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5IiwianRpIjoiZTg2ZWQ3ZDE3NDQ1YjBiZTQ4ODg4ZTcxZWIzNDU2NzAyMDRmNmNhNWU0ODViMDVmOThmYWE4NjI5MzQ5ZmVlZmM3ODY2MWY5YWQ4YjE1ZTYiLCJpYXQiOjE3NTIyMzYzODguMDA1OTM1LCJuYmYiOjE3NTIyMzYzODguMDA1OTM4LCJleHAiOjE3ODM3NzIzODcuOTk5OTc4LCJzdWIiOiIzNDcyIiwic2NvcGVzIjpbXX0.ixFmabizDACIrzVtoK5_W489TZ0--dUFuljwgxpskVi0lguGroJPgtbA7Z6FOt9T8scjjVALvdiKHcarHc3oihwZ0ntsZfrWZdMNfOAhNC0pCKjLXIGiDeSBSR2u630ZUJR2IfJqln3vX13aZH-RwZXP0SdLcKbWxBpa4EyPGuLzsPEuikyspKh5lF3hO2obZd7NAAQxS3Qii5QADCOUrLlYi9P6ipwfeUuzi1elyERTEzPsZXDks7L24Fqz8PK6X9H_a5NbG8UMRHbo1VemOzW6TDxHnjlkWuy0ttCb2ffnTm6pKP-VsDcHyQghi_kmrtVg87uFDYAHHKYV2V5VSur-pOTpO2YrnOW4x0lMNvV1xTwrWwMtOwn71VP10oW2Ii41L4uT07JSjJ9KkQiaxhgBCYEyp2K_ptYu-mZIcsMHgUPLSrXFZtUcC1FS4kTV-GUXIrNiEMVVdMfEe232Qv_fzgbn0qV8l75gaW8l32rK0rtT59A1RPe1IMDX0UcALrK5AEP-AadMuAOav0StjUdfW1S0IBUdnxB9BOZTkuLMDNsXgzzIYgfkVbO7zUNvGmU1im0iyxINvBWxGtn4q-AYo4TBxXa3BVqA_om61mEReCDDK5hMowrjZsKAQ-vgiVk52Zp_wMQFYK9vgXdXRGe_MAoOKqKoNlvrRmvIWr0`;
        request.headers['Authorization'] = `Bearer ${token}`;

    }

    if (request.method !== 'get' && request.headers['Content-Type'] !== 'multipart/form-data' && request.meta?.wrap === true) {
        request.data = { data: request.data };
    }
    
    return request;
}, (error) => {
    return Promise.reject(error);
});

/* Response interceptor */
// axiosInstance.interceptors.response.use(response=> {
// 	let decodedData	=	response.data;
// 	response.data	= 	decodedData;
// 	return response;
// },(error)=>{
// 	/* Do something with response error */
// 	return Promise.reject(error);
// });

/* Response Interceptor */
axiosInstance.interceptors.response.use((response) => {
    return response;
}, (error) => {
    return Promise.reject(error);
});

export default axiosInstance;